import moment from 'moment'

export const formatDateForDisplay = (dateString) => {
	if (!dateString) return ''

	const date = moment(dateString)
	if (!date.isValid()) return dateString

	return date.format('MMM DD, YYYY')
}

export const formatDateForAPI = (dateString) => {
	if (!dateString) return ''

	const date = moment(dateString, 'MMM DD, YYYY')
	if (!date.isValid()) return dateString

	return date.toISOString()
}

export const addItemToArray = (array, newItem) => {
	return [...array, newItem]
}

export const removeItemFromArray = (array, index) => {
	return array.filter((_, i) => i !== index)
}

export const updateItemInArray = (array, index, updatedItem) => {
	return array.map((item, i) => i === index ? updatedItem : item)
}

// The resume parser emits "Unknown" when it cannot determine a degree level. That is a
// sentinel, not a real value, and it is absent from masterStore.degreeLevels - passing it
// to the picker leaves it in a broken state, so treat it as empty.
const DEGREE_LEVEL_SENTINELS = ['unknown', 'n/a', 'na', 'none']

export const normalizeDegreeLevel = (value) => {
	if (!value) return ''
	return DEGREE_LEVEL_SENTINELS.includes(String(value).trim().toLowerCase()) ? '' : value
}

export const createEmptyEducationItem = () => ({
	id: null,
	school: '',
	degreeLevel: '',
	degreeName: '',
	areaOfStudy: '',
	startDate: '',
	endDate: '',
	graduationDate: '',
	gpa: '',
	city: '',
	state: ''
})

export const createEmptyWorkItem = () => ({
	id: null,
	company: '',
	position: '',
	startDate: '',
	endDate: '',
	isCurrent: false,
	address1: '',
	address2: '',
	city: '',
	state: '',
	country: '',
	zipcode: ''
})